import * as actionType from 'actions';

export const tabChange = (value) => ({
    type: actionType.TAB_CHANGE,
    value
});

export const nextStepAction = (value) => ({
    type: actionType.NEXT_STEP,
    value
});

export const backStepAction = (value) => ({
    type: actionType.BACK_STEP,
    value
});

export const completedStepsAction = (value) => ({
    type: actionType.COMPLETED_STEPS,
    value
});

export const resetStepAction = (value) => ({
    type: actionType.RESET_STEP
});

export const setStepsCountAction = (value) => ({
    type: actionType.STEPS_COUNT,
    value
});

export const selectStepperAction = (value) => ({
    type: actionType.SELECT_STEPPER,
    value
});

export const enableAllSteppersAction = (value) => ({
    type: actionType.ENABLE_ALL_STEPPERS,
    value
});

export const changeSection = value => ({
    type: actionType.SET_SECTION,
    value
});

export const handleTotalSteps = value => ({
    type: actionType.SET_STEPS,
    value
});

export const setLogoutClick = value => ({
    type: actionType.SET_LOGOUT_CLICK,
    value
});